import toast from "react-hot-toast";
import { axiosInstance } from "../components/lib/axios";

export const getHomeData = async () => {
    try {
        const res = await axiosInstance.get(
            `/home`
        );
        console.log(res.data.data);
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const getBannerData = async (pageName) => {
    try {
        const res = await axiosInstance.get(
            `/banner/${pageName}`
        );
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

export const getCapabilityData = async () => {
    try {
        const res = await axiosInstance.get(
            `/home/capability`
        );
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

// const getAllUserFunctionApi = async (pageNumber, pageSize, search, field) => {
//     try {

//         const params = new URLSearchParams();
//         params.append('field', field);
//         params.append('search', search);
//         params.append('pageSize', pageSize);
//         params.append('pageNumber', pageNumber);

//         const accessToken = Cookies.get("accessToken");
//         const res = await axiosInstance.get(`/users/getuser?${params.toString()}`, {
//             headers: {
//                 Authorization: `Bearer ${accessToken}`,
//             },
//         })
//         // toast.success("Successfully fetched!");
//         return res.data.data
//         // console.log("lorem")

//     } catch (err) {
//         console.log(err.response?.data?.message)
//         toast.error(err.response?.data?.message || "Something went wrong!");
//     }
// }
